import { createElement, memo, useMemo, useState, useEffect, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import CitySelectionModal from '../CitySelection/CitySelectionModal';
import Image from '@hfe/max-image';
import './index.scss';
const MyComponent = (props) => {
    const { citydata, allCityStyle, checkedCity, isTop, zIndex, cityInfo, _LXReport, _communication } = props;
    const { isDrop, dropHeight, checkedColor, uncCheckedColor, checkedBgColor, unCheckedBgColor, scrollBgColor, dropType } = allCityStyle;
    const [city, setCity] = useState(checkedCity);
    const [visible, setVisible] = useState(false);
    const [scrollIdx, setScrollIdx] = useState(0);
    const scrollRef = useRef(null);
    useEffect(() => {
        setCity(checkedCity);
    }, [checkedCity]);
    const onClick = (item) => {
        handleCityChange(item);
        _communication === null || _communication === void 0 ? void 0 : _communication.emit('cityChanged', item);
        console.log('web emit citychange', item === null || item === void 0 ? void 0 : item.value);
    };
    const handleCityChange = (city) => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport('b_daodian_lowcode_s1i934ut_mc', {
            valLab: {
                item_name: city === null || city === void 0 ? void 0 : city.title,
                item_index: city === null || city === void 0 ? void 0 : city.value
            }
        });
        setCity(city);
        setVisible(false);
    };
    useEffect(() => {
        const dom = document.querySelector('body');
        dom === null || dom === void 0 ? void 0 : dom.addEventListener('click', () => {
            if (dropType === 'dropDown')
                setVisible(false);
            setScrollIdx(0);
        }, false);
        return dom === null || dom === void 0 ? void 0 : dom.removeEventListener('clcik', () => { }, false);
    }, []);
    const onScroll = (e) => {
        // 近似获取当前滚动到哪个城市
        const idx = Math.floor(e.detail.contentOffset.x * 6 / window.innerWidth);
        setScrollIdx(idx);
    };
    const defaultScroll = (visible) => {
        if (visible) {
            setScrollIdx(0);
        }
        else if (dropType === 'dropDown') {
            const id = setInterval(() => {
                if (scrollRef.current) {
                    clearInterval(id);
                    scrollRef.current.scrollTo({
                        y: Math.floor(scrollIdx / 6) * 128 * window.innerWidth / 750
                    });
                }
            }, 100);
        }
    };
    const isShow = useMemo(() => {
        if (isTop) {
            return 'none';
        }
        return 'flex';
    }, [isTop]);
    return <View className='city_horizontal'>
            <ScrollView x-if={!isDrop} horizontal={true}>
                <View className='city_horizontal_scroll'>
                    {isTop && <View className='city_horizontal_card' style={{
        backgroundColor: checkedBgColor
    }}>
                                <Text className='city_horizontal_card_text' style={{
        color: checkedColor
    }}>{city === null || city === void 0 ? void 0 : city.title}</Text>
                            </View>}
                    {citydata === null || citydata === void 0 ? void 0 : citydata.map((item, index) => <View className='city_horizontal_card' style={{
        backgroundColor: item.value == city.value ? checkedBgColor : unCheckedBgColor,
        display: item.value == city.value ? isShow : 'flex'
    }} onClick={() => {
        onClick(item);
    }}>
                                <Text className='city_horizontal_card_text' style={{
        color: item.value == city.value ? checkedColor : uncCheckedColor
    }}>
                                    {item === null || item === void 0 ? void 0 : item.title}
                                </Text>
                            </View>)}
                </View>
            </ScrollView>
            <View x-if={isDrop} horizontal={true} className='city_horizontal_content' style={visible ? {
        flexWrap: 'wrap',
        backgroundColor: scrollBgColor
    } : {
        backgroundColor: scrollBgColor
    }}>

                <ScrollView x-if={dropType === 'popup' || !visible} horizontal={true} onScroll={onScroll} scrollEventThrottle={16}>
                    <View style={{
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '24rpx'
    }}>
                        {isTop && <View className='city_horizontal_card' style={{
        backgroundColor: checkedBgColor
    }}>
                                    <Text className='city_horizontal_card_text' style={{
        color: checkedColor
    }}>{city === null || city === void 0 ? void 0 : city.title}</Text>
                                </View>}
                        {citydata === null || citydata === void 0 ? void 0 : citydata.map((item, index) => <View className='city_horizontal_card' style={{
        backgroundColor: item.value == city.value ? checkedBgColor : unCheckedBgColor,
        display: item.value == city.value ? isShow : 'flex'
    }} onClick={() => {
        onClick(item);
    }}>
                                    <Text className='city_horizontal_card_text' style={{
        color: item.value == city.value ? checkedColor : uncCheckedColor
    }}>
                                        {item === null || item === void 0 ? void 0 : item.title}
                                    </Text>
                                </View>)}
                    </View>
                    <View style={{
        width: '60rpx'
    }}/>
                </ScrollView>
                <View x-if={dropType === 'dropDown' && visible} style={{
        height: `${dropHeight}rpx`,
        backgroundColor: scrollBgColor
    }}/>

                {dropType === 'dropDown' && visible && <ScrollView style={{
        height: `${dropHeight}rpx`,
        width: '100%',
        position: 'absolute',
        zIndex: zIndex || 999,
        backgroundColor: scrollBgColor
    }} ref={scrollRef}>
                    <View className="city-drop-down-modal" style={{
        backgroundColor: scrollBgColor,
        marginLeft: '24rpx',
        paddingRight: '20rpx'
    }}>
                      {isTop && <View x-if={visible} className='city_horizontal_card-1' style={{
        backgroundColor: checkedBgColor
    }}>
                                  <Text className='city_horizontal_card_text' style={{
        color: checkedColor
    }}>{city === null || city === void 0 ? void 0 : city.title}</Text>
                              </View>}

                      {citydata === null || citydata === void 0 ? void 0 : citydata.map((item, index) => <View x-if={visible} className='city_horizontal_card-1' style={{
        backgroundColor: item.value == city.value ? checkedBgColor : unCheckedBgColor,
        display: item.value == city.value ? isShow : 'flex'
    }} onClick={() => {
        onClick(item);
        setScrollIdx(0);
    }}>
                                  <Text className='city_horizontal_card_text' style={{
        color: item.value == city.value ? checkedColor : uncCheckedColor
    }}>
                                      {item === null || item === void 0 ? void 0 : item.title}
                                  </Text>
                              </View>)}
                    </View>
                  </ScrollView>}
                <View className='city_horizontal_position' style={dropType === 'dropDown' && visible ? {
        zIndex: zIndex || 999
    } : {}}>
                    {!visible && <LinearGradient className="city_horizontal_position_left" start={{
        x: 0,
        y: 1
    }} end={{
        x: 1,
        y: 1
    }} colors={['rgba(255,255,255,0)', scrollBgColor]}/>}
                    <View className="city_horizontal_position_right" style={{
        background: scrollBgColor
    }} onClick={e => {
        setVisible(!visible);
        defaultScroll(visible);
        e.stopPropagation();
    }}>
                        <Image className="base1" source={visible ? {
        uri: 'https://p0.meituan.net/ingee/85a79c1950d30cb31aa2d67d6542fb833833.png'
    } : {
        uri: 'https://p0.meituan.net/travelcube/302d8cc1e549511799fd2f05135966752426.png'
    }}/>
                    </View>
                </View>
                <CitySelectionModal x-if={dropType === 'popup' && visible} visible={dropType === 'popup' && visible} city={city === null || city === void 0 ? void 0 : city.title} onCityChange={handleCityChange} onClose={() => setVisible(false)} cityData={cityInfo} {...props}/>
            </View>
        </View>;
};
export default memo(MyComponent);
